export default "/static/83f95becb9f075b2.png"